<div class="tenant-selector" *ngIf="hasMultipleTenants()">
  <div class="dropdown" [class.show]="dropdownOpen" (clickOutside)="closeDropdown()">
    <button 
      class="btn btn-outline-secondary dropdown-toggle btn-sm w-100" 
      type="button" 
      (click)="toggleDropdown()"
      [disabled]="switching"
      title="{{ 'TenantSwitch.SelectTenant' | translate }}">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-1">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M3 21h9" />
        <path d="M9 8h1" />
        <path d="M9 12h1" />
        <path d="M9 16h1" />
        <path d="M14 8h1" />
        <path d="M14 12h1" />
        <path d="M5 21v-16c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h10c.53 0 1.039 .211 1.414 .586c.375 .375 .586 .884 .586 1.414v7" />
        <path d="M16 18c0 .53 .211 1.039 .586 1.414c.375 .375 .884 .586 1.414 .586c.53 0 1.039 -.211 1.414 -.586c.375 -.375 .586 -.884 .586 -1.414c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414z" />
        <path d="M18 14.5v1.5" />
        <path d="M18 20v1.5" />
        <path d="M21.032 16.25l-1.299 .75" />
        <path d="M16.27 19l-1.3 .75" />
        <path d="M14.97 16.25l1.3 .75" />
        <path d="M19.733 19l1.3 .75" />
      </svg>
      <span class="tenant-name text-truncate d-inline-block" style="max-width: 150px;">
        {{ currentTenant?.displayName || ('TenantSwitch.SelectTenant' | translate) }}
      </span>
    </button>
    
    <ul class="dropdown-menu" [class.show]="dropdownOpen">
      <li class="dropdown-header">{{ 'TenantSwitch.AvailableTenants' | translate }}</li>
      <li *ngFor="let tenant of availableTenants">
        <a 
          class="dropdown-item" 
          [class.active]="tenant.isCurrent"
          [class.disabled]="tenant.isCurrent || switching"
          (click)="switchTenant(tenant)">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M3 21h18" />
            <path d="M9 8h1" />
            <path d="M9 12h1" />
            <path d="M9 16h1" />
            <path d="M14 8h1" />
            <path d="M14 12h1" />
            <path d="M14 16h1" />
            <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
          </svg>
          {{ tenant.displayName }}
          <span class="badge badge-soft-primary ms-auto" *ngIf="tenant.isCurrent">
            {{ 'TenantSwitch.Current' | translate }}
          </span>
        </a>
      </li>
    </ul>
  </div>
  
  <div class="spinner-border spinner-border-sm text-primary" *ngIf="switching" role="status">
    <span class="visually-hidden">{{ 'TenantSwitch.Switching' | translate }}</span>
  </div>
</div>
